const accTitles = document.querySelectorAll(".accordion-Title");

accTitles.forEach((title) => {
  title.addEventListener("click", function () {
    const parent = this.parentNode;
    const content = parent.querySelector(".accordion-content");

    if (parent.classList.contains("active")) {
      parent.classList.remove("active");
      content.style.height = `0px`;
    } else {
      accTitles.forEach((t) => {
        const p = t.parentNode;
        const c = p.querySelector(".accordion-content");
        p.classList.remove("active");
        c.style.height = `0px`;
      });

      parent.classList.add("active");
      content.style.height = `${content.scrollHeight}px`;
    }
  });
});


// accordion item excerpt

document.addEventListener("DOMContentLoaded", function () {
  const accItems = document.querySelectorAll(".acc_wrap");
  const viewMoreBtn = document.querySelector(".accContentWrapper button");
  const initialVisibleCount = 6;
  let isExpanded = false;

  // Hide items beyond the first 6
  accItems.forEach((item, index) => {
    if (index >= initialVisibleCount) {
      item.classList.add("hidden");
    }
  });

  function updateButtonText() {
  viewMoreBtn.innerHTML = isExpanded
    ? '<span>VIEW LESS</span> <span>-</span>'
    : '<span>VIEW MORE</span> <span>+</span>';
  }

  updateButtonText();

  viewMoreBtn.addEventListener("click", function () {
    isExpanded = !isExpanded;

    accItems.forEach((item, index) => {
      if (index >= initialVisibleCount) {
        item.classList.toggle("hidden", !isExpanded);
      }
    });

    updateButtonText();
  });
});

